import { autoinject } from "aurelia-framework";
import { I18N } from "aurelia-i18n";
import { HttpResponseMessage } from "aurelia-http-client";
import { Router } from "aurelia-router";
import {
  ValidationRules,
  ValidationControllerFactory,
  ValidationController,
  ControllerValidateResult,
} from "aurelia-validation";
import { AuthService } from "../../services/auth/auth-service";
import { BootstrapFormRenderer } from "../../validation/bootstrap-form-renderer";

@autoinject
export class Login {
  oldpassword: string;
  newpassword: string;
  retypedpassword: string;
  passwordChangeError?: string;

  private validationController: ValidationController;

  constructor(
    private i18n: I18N,
    private validationControllerFactory: ValidationControllerFactory,
    private authService: AuthService,
    private router: Router,
  ) {
    this.validationController =
      this.validationControllerFactory.createForCurrentScope();
    this.validationController.addRenderer(new BootstrapFormRenderer());

    ValidationRules.ensure((d: Login) => d.oldpassword)
      .displayName(this.i18n.tr("auth.oldpassword") as string)
      .required()
      .withMessageKey("auth.oldpasswordRequired")
      .maxLength(200)
      .ensure((d: Login) => d.newpassword)
      .displayName(this.i18n.tr("auth.newpassword") as string)
      .required()
      .withMessageKey("auth.newpasswordRequired")
      .minLength(4)
      .maxLength(200)
      .ensure((d: Login) => d.retypedpassword)
      .displayName(this.i18n.tr("auth.retypedpassword") as string)
      .required()
      .withMessageKey("auth.retypedpasswordRequired")
      .minLength(4)
      .maxLength(200)
      .then()
      .satisfies((v, o) => v === o!.newpassword)
      .withMessageKey("auth.newpasswordAndVerificationDontMatch")
      .on(this);
  }

  changePassword() {
    this.passwordChangeError = undefined;
    this.validationController
      .validate()
      .then((result: ControllerValidateResult) => {
        if (!result.valid) return;
        return this.authService
          .changePassword({
            username: this.authService.getTokenPayload().sub,
            oldPasswordHash: this.authService.hash(this.oldpassword),
            newPasswordHash: this.authService.hash(this.newpassword),
          })
          .then((_) => {
            this.passwordChangeError = undefined;
            this.router.navigateToRoute("passwordChanged");
          })
          .catch((err: HttpResponseMessage) => {
            console.log("passwordChange failure", err);
            this.passwordChangeError =
              err.statusCode == 401
                ? "passwordChangeErrorInvalidPassword"
                : "passwordChangeError";
          });
      });
  }
}
